
import Vue from "vue"
import { uniq } from 'lodash'

// Helper function to remove paused onboardings older than 3 days
const cleanExpiredPausedOnboardings = () => {
    const pausedOnboarding = JSON.parse(localStorage.getItem('pausedOnboarding') || '[]')
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000
    const now = Date.now()
    
    const validOnboardings = pausedOnboarding.filter(item => {
        if (!item.pausedAt) {
            // If no timestamp, remove it (legacy data)
            return false
        }
        const pausedTime = new Date(item.pausedAt).getTime()
        return (now - pausedTime) < threeDaysInMs
    })
    
    if (validOnboardings.length !== pausedOnboarding.length) {
        localStorage.setItem('pausedOnboarding', JSON.stringify(validOnboardings))
    }
    
    return validOnboardings
}

const integrations = {
    state: {
        pausedOnboarding: cleanExpiredPausedOnboardings(),
        publicAppsOnboarding: null,
        onboardingRefreshKey: 0
    },
    actions: {
        pauseOnboarding({commit, getters}) {
            commit('PAUSE_ONBOARDING', {
                project_uuid: getters.getCurrentProject.uuid
            })
        },

        unpauseOnboarding({commit, getters}) {
            commit('UNPAUSE_ONBOARDING', {
                project_uuid: getters.getCurrentProject.uuid
            })
        },

        async fetchPublicAppsOnboarding({state}) {
            const { data } = await this._vm.$http.get("/v3/system/gateway/app-service/public-app/onboarding")
            state.publicAppsOnboarding = data

            return data
        }
        
    },
    mutations: {
        PAUSE_ONBOARDING (state, data) {
            state.pausedOnboarding.push({
                ...data,
                pausedAt: new Date().toISOString()
            })

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_ONBOARDING (state, id) {
            state.pausedOnboarding = state.pausedOnboarding.filter(i => {
                return i.id != id && i.project_uuid == state.currentProject
            })

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_ONBOARDING_ALL (state) {
            Vue.set(state, 'pausedOnboarding', [])
            localStorage.setItem("pausedOnboarding", JSON.stringify([]))
        },

        REFRESH_ONBOARDING (state) {
            state.onboardingRefreshKey++
        },

        INTEGRATION_ONBOARDED (state, id) {
            const items = state.items.map(i => {
                if (i.id == id && type == "integration") {
                    i.onboarding.status = "completed"
                }

                return i
            })

            Vue.set(state, 'items', items)
        },

        APP_ONBOARDED (state, id) {
            const items = state.items.map(i => {
                if (i.id == id && type == "app") {
                    i.onboarded = true
                }

                return i
            })

            Vue.set(state, 'items', items)
        }
    },
    getters: {
        getPausedOnboardings(state) {
            return state.pausedOnboarding || []
        },

        getOnboardingRequiredIntegrations(state, getters) {
            return getters.getIntegrations.filter(i => {
                const { onboarding } = i
                if (onboarding) {
                    return onboarding.status !== 'completed'
                }

                return false
            })
        },

        getOnboardingRequiredPlatformApps(state, getters) {
            return getters.getApps.filter(app => {
                return app.onboarding.required && !app.onboarding.finished
            })
        },

        getOnboardingRequiredPublicApps(state) {
            return state.publicAppsOnboarding
        },

        getOnboardingRefreshKey(state) {
            return state.onboardingRefreshKey
        }
    }
  }

export default integrations